import React, { useMemo, useState } from 'react';
import Star from "../../../Assests/star.svg";
import activeStar from "../../../Assests/activeStar.svg";
import pendingStar from "../../../Assests/pendingStar.svg";
import { updateStarUser } from '../../../Services/ShowsApi';
import { API_STATUS } from '../../../utils/constant';
import { toggleSearchPageLoad } from '../../../redux/valueSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../../redux/alertSlice';
import { getUserProfileDetails } from '../../../Services/ShowsApi';
import { setData } from '../../../redux/userSlice';


const StaredUser = ({ startActive, userId }) => {
    const [active, setActive] = useState(startActive);
    const dispatch = useDispatch();
    const user = useSelector((state) => state?.user || []);
    const userProfile = useSelector((state) => state?.user || {});
    const { starCount } = userProfile;


    const styles = {
        star: {
            width: "3.2vh",
            height: "3.2vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        pendingStar: {
            width: "3.4vh",
            height: "3.4vh",
        }
    };

    const handleStarUser = async () => {
        let startedProfileLimit = 5;
        let loggedUser = localStorage.getItem('user_id');
        let status = startActive ? false : true

        if (startedProfileLimit > starCount || !status) {
            setActive(2);
            let data = {
                "UserID1": loggedUser,
                "UserID2": userId,
                "Starred": status
            }

            let res = await updateStarUser(data)
            if (res.status == API_STATUS.success) {
                dispatch(toggleSearchPageLoad());
                status ? setActive(1) : setActive(0)

                const { data } = await getUserProfileDetails("UserID");
                let { Data } = data?.body
                if (Array.isArray(Data) && Data.length > 0) {
                    dispatch(setData(Data[0]))
                } else if (typeof Data === 'object') {
                    dispatch(setData(Data))
                }
            }

        } else {
            dispatch(setAlert({
                message: "You have reached the maximum number of starred connections !",
                type: "Warning", isAlertOpen: true
            }))
        }

    };

    const starStatus = useMemo(() => {
        const commonProps = {
            onClick: handleStarUser,
            style: styles.star,
        };

        switch (active) {
            case 2:
                return {
                    ...commonProps,
                    img: pendingStar,
                    style: { ...styles.star, ...styles.pendingStar },
                };
            case 1:
                return {
                    ...commonProps,
                    img: activeStar,
                };
            case 0:
            default:
                return {
                    ...commonProps,
                    img: Star,
                };
        }
    }, [active, handleStarUser]);

    return (
        <div
            style={starStatus.style}
            onClick={starStatus.onClick}
        >
            <img src={starStatus.img} className="pointer" alt="star status" />
        </div>
    );
};

export default StaredUser;
